import type ReadingPaneLogStore from "./schema/ReadingPaneLogStore";

export const readingPaneLogStore: ReadingPaneLogStore = {
    readingPaneLogs: [],
};
